import axios from "axios";

export async function loadCompetencies(params) {
  return axios
    .get("/competencies?show=categories", { params })
    .then(r => r.data);
}

export async function loadCompetenciesWithDocs(params) {
  return axios.get("/competencies?show=docs", { params }).then(r => r.data);
}

export async function loadCompetence(params) {
  const url = `/competencies/${params.competenceId}/categories/${
    params.categoryId
  }`;

  return axios.get(url).then(r => r.data);
}

export async function loadManagers(params) {
  return axios.get("/managers/competencies", { params });
}

export async function loadCategories() {
  return axios.get("/categories?per_page=-1").then(r => r.data);
}
